import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, CardBody, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';
import { Elements } from 'react-stripe-elements'
import PaymentForm from '../components/e-commerce/payment/components/PaymentForm'

class PurchaseModal extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        // this.state = {
        //   modal: false
        // };

        this.toggle = this.props.toggle;
    }

    // toggle() {
    //   this.setState({
    //     modal: !this.state.modal
    //   });
    // }

    // removeFromCart() {
    //   {data: removedData} = this.props.client.mutation
    // }

    render () {
        //console.log(this.props.ct)
        let Icon;
        // const { ComingSoon, DropZone, Collapse, Msg } = this.props;

        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon' />;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon' />;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon' />;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon' />;
                break;
            default:
                break;
        }

        return (
            <div>
                {this.props.children}
                <Modal isOpen={this.props.modal}
                    className={`modal-dialog--${this.props.color} ${this.props.colored ?
                        'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''} 
            ${this.props.className}`}
                >
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle} />

                        <h3 className='compliance-toggle-title'
                            style={{ padding: '75px 0 0' }}>Complete Your Purchase</h3>
                        <hr />
                    </div>
                    <div className='modal__body'>
                        <p><span>{Icon}</span> {this.props.Msg}</p>
                        <div style={{ width: '100%' }}>
                            <div>
                                <CardBody className='responsivePayment'>
                                    <Col className='paymentInfo'>
                                        <div className='payment'>
                                            <Elements>
                                                <PaymentForm
                                                    price={this.props.price}
                                                />
                                            </Elements>
                                        </div>
                                    </Col>
                                </CardBody>
                            </div>
                        </div>
                    </div>
                    {/* {this.props.showButtonBar ? <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.toggle}>Cancel</Button>{' '}
                        <Mutation mutation={RemoveProductFromCart}
                            onCompleted={() => {
                                const { ct } = this.props;
                                this.toggle();
                                this.props.confirmDelete(ct.productID ? ct.productID : 
                                    ct.productName, ct.price, ct.quantity)
                            }}>
                            {(removeProductFromCart) => (
                                <Button outline={this.props.colored} color={this.props.color} onClick={() => {
                                    removeProductFromCart({
                                        variables: {
                                            productId: this.props.ct.productID ? this.props.ct.productID
                                                : this.props.ct.productName
                                        }
                                    })
                                }}>I'm Sure</Button>
                            )}
                        </Mutation>
                    </ButtonToolbar> : null} */}

                </Modal>
            </div>
        );
    }
}
export default withRouter(withApollo(PurchaseModal))


// WEBPACK FOOTER //
// ./src/components/PurchaseModal.js